export default __webpack_public_path__ + "static/media/received-requests.b7128515.svg";